import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-175" data-mp="3peam4j0ug885">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-900/95 px-4 py-3 backdrop-blur lg:hidden" data-id="element-176" data-mp="3ud545iqzlsr7">
          <div className="flex items-center justify-between gap-4" data-id="element-177" data-mp="c5pgpjrcp4d7">
            <div className="text-white" data-id="element-178" data-mp="gyqz41qrnm1j">
              <p className="font-display text-lg font-bold leading-none" data-id="element-179" data-mp="gztqsbvwxsii">$19 USD</p>
              <p className="mt-1 text-xs text-sand-100/70" data-id="element-180" data-mp="765i30r9owfg">Pago único · acceso hoy</p>
            </div>
            <CtaButton size="md" data-id="element-181" data-mp="28m3fzqnqhmz">Quiero el protocolo</CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}